var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7817 48.9992C97.7817 51.1944 97.5378 53.6334 97.2939 55.8285C94.1231 79.2431 74.367 97.2919 50.2207 97.7797C49.7329 97.7797 49.489 97.7797 49.0012 97.7797C22.1719 97.7797 0.220703 75.8285 0.220703 48.9992C0.220703 21.9261 22.1719 0.21875 49.0012 0.21875C75.8305 0.21875 97.7817 21.9261 97.7817 48.9992Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2953 55.8307C94.1246 79.2454 74.3685 97.2942 50.2221 97.782L33.1693 83.1667L39.2465 64.3673L29.8359 51.5L63.1693 15.25L97.2953 55.8307Z",
    fill: "#FFF9C5",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5629 15.25H63.1861L49.9977 40.1775H69.418L33.1861 83.366L43.7658 51.4819H29.418L39.5629 15.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/points_icon.a4067a3cd3c5e920a9a2b6aeb56046d5.svg";
export { ForwardRef as ReactComponent };